// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/bg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  --color1: #61a4bc;
  --color2: #1a132f;
  --aqua3: mediumaquamarine;
  --color4: #bbeff8ce;
  --boxshadow: #e6e1e1ce;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
}

*{
  box-sizing: border-box;
}

button.btn-sm.btn.btn-color.mx-5 {
  color: black;
}

.category_post_img img,
.feature-img img {
  width: 100%;
}

.all_post .sidebar_widget .single_sidebar_wiget {
  padding: 30px;
  margin-bottom: 30px;
}

.a_un_underline:hover {
  text-decoration: none;
  color: black
}

.test {
  position: absolute;
  width: 80vw;
  height: 80vw;
  background-color: red;
  top: -20vw;
  left: -20vw;
  border-radius: 200px;
  transform: rotate(45deg);
}

.navbar-brand {
  width: 216px;
  margin: 0px;
  display: flex;
  align-items: center;

}

.logo {
  color: white;
  transition: linear 1s;
  font-family: "Oleo Script", cursive;
}

.logo:hover {
  background: linear-gradient(90deg,
      rgb(247, 64, 207) 0%,
      rgba(11, 113, 172, 0.966) 100%);
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
}

.truncate {
  width: 95%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

h1.text-color {
  font-weight: 400;
}

h1.text-color span {
  font-weight: 700;
}

.uk-card.uk-card-default.uk-card-hover.uk-card-body.form-section {
  width: 100%;
}

ul.navbar-nav.sp-font.h5 {
  display: flex;
  column-gap: 80px;
}

nav.navbar.navbar-expand-lg.navbar-light.bg-light::after {
  /* content: ''; */
  background-image: url(https://png.pngtree.com/background/20211217/original/pngtree-noise-texture-abstract-black-gray-white-background-picture-image_1575985.jpg);
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  border-radius: 10px;
  background-size: inherit;
  z-index: -1;
  /* opacity: 0.5; */
  background-image: url(https://media.istockphoto.com/id/1317698849/vector/space-starry-backdrop-deep-cosmic-wallpaper-wide-cosmos-with-shining-stars-beautiful.jpg?s=612x612&w=0&k=20&c=ZfgqI_ODv-v9PprIZAMVZ8Jyfo5tRWUERsbjzcLWLiE=);
}

.navbar {
  background: rgb(0, 212, 255);
  /* background: linear-gradient(90deg,
      rgba(0, 212, 255, 1) 11%,
      rgba(100, 209, 78, 1) 98%); */
  position: sticky;
  top: 0px;
  z-index: 2;
  width: 98%;
  margin: 10px auto;
  border-radius: 10px;
}

.headline {
  font-family: "Oleo Script", cursive;
  color: var(--aqua3);
  box-shadow: -1.6px 3px 10px var(--color4);
  border-radius: 0.5em;
  margin-bottom: 3vh;
}

.headline:hover {
  cursor: default;
}

.card {
  border-radius: 1em;
  transition: cubic-bezier(0.075, 0.82, 0.165, 1) 1s;
  box-shadow: -1.6px 3px 10px var(--boxshadow);
  z-index: 1;
}

.card:hover {
  transform: scale(1.01);
}

.card-img-top {
  border-radius: 1em 1em 0.1em 0.1em;
}

.page-button {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.nav-link {
  color: white !important;
  transition: cubic-bezier(0.175, 0.885, 0.32, 1.275) 1s;
}

.nav-link:hover {
  background: linear-gradient(90deg,
      rgb(247, 64, 207) 0%,
      rgba(11, 113, 172, 0.966) 100%);
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;

  transform: scale(1.03);
}

.navbar-toggler {
  background-color: var(--color1) !important;
}

.btn-color {
  background-color: var(--color1);
  color: white;
}




/* news */

.list-news-subfolder .item-news-common {
  padding-top: 20px;
  margin-top: 20px
}

.list-news-subfolder .item-news-common .title-news {
  margin-bottom: 5px;
  font-size: 18px;
  font-weight: bold
}

.list-news-subfolder .item-news-common .thumb-art {
  width: 260px;
  margin-right: 0;
  float: right;
  margin-left: 40px
}

.list-news-subfolder .item-news-common .description {
  font-size: 14px;
  line-height: 140%;
  color: #4f4f4f !important
}

.infinite-scroll-component {
  overflow-x: hidden !important;
}

.list-news-subfolder .item-news-common.off-thumb .title-news,
.list-news-subfolder .item-news-common.off-thumb .description {
  max-width: 600px
}

.list-news-subfolder .item-news-common:first-of-type {
  margin-top: 0;
  padding-top: 0
}

.list-news-subfolder .item-news-common.thumb-left {
  padding-right: 20px
}

.list-news-subfolder .item-news-common.thumb-left .thumb-art {
  float: left;
  width: 240px;
  margin: 0 20px 0 0
}

.wrapper-24h .col-left-subfolder {
  width: 780px;
  padding-right: 20px
}

.wrapper-24h .col-right-subfolder {
  width: 320px;
  padding-left: 20px
}


.wrapper-24h .list-news-subfolder .item-news-common {
  padding-left: 30px;
  position: relative;
  border-top: none;
  margin-top: 20px;
  padding-top: 20px;
  width: 100%;
}

.wrapper-24h .list-news-subfolder .item-news-common:first-of-type {
  margin-top: 0;
  padding-top: 0
}

.wrapper-24h .list-news-subfolder .item-news-common .title-news {
  font-size: 18px;
  font-weight: 700
}

.wrapper-24h .ant-list-items {
  transform: translateX(12px);
  border-left: 1px solid #e5e5e5;
}

.wrapper-24h .time-count {
  font-size: 14px;
  width: 100%;
  float: left;
  position: relative;
  color: #757575
}

.rc-virtual-list-holder {
  overflow-y: visible !important;
}

.wrapper-24h .time-count:before {
  content: "";
  width: 9px;
  height: 9px;
  background: #9f224e;
  border-radius: 50%;
  position: absolute;
  top: 3px;
  left: -35px;
  z-index: 1
}

.wrapper-24h .filter-viewmore {
  align-items: center;
  justify-content: flex-end;
  font-size: 14px;
  color: #757575;
  position: absolute;
  top: -84px;
  right: 0
}

.wrapper-24h .filter-viewmore .txt-fil {
  margin-right: 5px
}

.wrapper-24h .filter-viewmore .btn_vne {
  height: 32px;
  font-size: 15px;
  color: #757575;
  line-height: 32px;
  padding: 0 10px;
  background: #f7f7f7;
  border-radius: 3px;
  margin-left: 5px
}
.single_catagory_post{
  padding: 20px 0;
}

.single_catagory_post ~ .single_catagory_post {
    border-top: 1px solid #1ca2fb61;
}
.ant-skeleton.ant-skeleton-element.ant-skeleton-active ,.ant-skeleton-image{
  width: 100%;
  min-width: 100%;
  height: 180px;
  min-height: 180px;
}
.category_post_img{
  width: 100%;
  height: 180px;
  position: relative;
}
.category_post_img img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.Detail img{
  width: 100%;
    height: auto;
    max-width: 100%;
    padding: 10px 0px;
}
.wrapper-24h .filter-viewmore .btn_vne.active {
  background: #9f224e;
  color: #fff
}

.wrapper-24h.wrapper-xemnhieu .list-news-subfolder {
  border-left: none
}

.wrapper-24h.wrapper-xemnhieu .list-news-subfolder .item-news-common {
  padding-left: 0;
  border-top: 1px solid #e5e5e5
}

.wrapper-24h.wrapper-xemnhieu .list-news-subfolder .item-news-common:first-of-type {
  border-top: none
}

.wrapper-24h.wrapper-xemnhieu .list-news-subfolder .item-news-common:first-of-type .title-news {
  color: #9f224e
}

.wrapper-24h.wrapper-hotnews .time-count {
  height: 0;
  font-size: 0;
  margin-bottom: 0
}

.wrapper-24h.wrapper-hotnews .time-count:before {
  top: 9px
}

a:focus {
  outline: 1 !important
}

a {
  color: inherit;
  text-decoration: none;
  outline: 1
}

.thumb-art {
  position: relative;
  margin-right: 10px;
  float: left;
  width: 140px
}

.thumb {
  display: block;
  overflow: hidden;
  height: 0;
  position: relative;
  width: 100%;
  background: #f4f4f4
}

.thumb img {
  object-fit: cover;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%
}


.thumb-5x3 {
  padding-bottom: 60%
}

.thumb-5x2 {
  padding-bottom: 40%
}

.thumb-3x2 {
  padding-bottom: 66.66667%
}

.thumb-16x9 {
  padding-bottom: 56.25%
}

.thumb-1x1 {
  padding-bottom: 100%
}

.thumb-2x3 {
  padding-bottom: 150%
}


.meta-news {
  color: #757575;
  font-size: 12px;
  line-height: 14px;
  font-weight: 400 !important;
  font-family: Arial
}

.meta-news .time-public {
  display: inline-block;
  margin-right: 10px
}

.meta-news .cat {
  display: inline-block;
  margin-right: 10px
}



.item-news-common {
  margin-bottom: 15px;
}

.item-news-common {
  border-bottom: none;
}

.sidebar-1 img {
  width: 100%;
}

.desc_cation p,
.desc_cation p.Image {
  /* font: 400 14px/160% arial; */
  padding: 10px 0 0 0;
  margin-bottom: 0;
  text-align: left;
}

.fck_detail .Normal,
.fck_detail p {
  margin: 0 0 1em;
  line-height: 160%;
  text-rendering: optimizeSpeed;
}

.sidebar-1 .header-content,
.sidebar-1 .title-detail {
  display: none;
}

@media screen and (max-width: 979px) {
  .page-detail.top-detail .sidebar-1 {
    max-width: calc(100% - 60px);
  }
}

@media screen and (max-width: 1129px) {
  .page-detail.top-detail .sidebar-1 {
    max-width: calc(100% - 360px);
  }

}

@media (max-width: 979px) {
  .page-detail.top-detail .sidebar-1 {
    max-width: calc(100% - 65px);
  }
}

@media screen and (max-width: 979px) {
  .page-detail.top-detail .sidebar-1 {
    max-width: 100%;
  }

}

@media screen and (max-width: 1129px) {
  .page-detail.top-detail .sidebar-1 {
    max-width: calc(100% - 320px);
  }

}

.page-detail.top-detail .sidebar-1 {
  width: 100%;
  max-width: calc(100% - 420px);
  padding: 20px 0 0 0;
}

@media screen and (max-width: 979px) {
  .page-detail .sidebar-1 {
    max-width: 100%;
  }

}

@media screen and (max-width: 1129px) {
  .page-detail .sidebar-1 {
    max-width: calc(100% - 320px);
  }

}

.sidebar-1 {
  font-size: 16px;
  width: 100%;
  padding: 20px 0 0 0;
  position: relative;
}
.fck_detail table.tplCaption td.caption, .fck_detail table.tplCaption td.Image, .fck_detail table.tplCaption td p.Normal, .fck_detail table.tplCaption td .Image, .fck_detail .tplCaption .Image {
  font: 400;
  line-height: 160%;
  color: #222;
  padding: 10px 0 0 0;
  margin: 0;
  text-align: left;
}
.fck_detail figure.tplCaption figcaption p {
  font: 400 13px/160% arial ;
  padding-top: 10px;
  margin-bottom: 0;
  font-style: italic;
}
picture img {
  position: absolute;
  width: 100%;
  left: 0;
  height: 100%;
}
.footer-content{
  display: none;
}
.sidebar-1 table{
  display: none;
}
p.Normal,p.description {
  text-align: justify;
}
figcaption p.Image{
  
}

.f-center{
  display: flex;
  justify-content: center;
  align-items: center;
}

.t-center{
  text-align: center;
}

#scrollableDiv{
  max-width: 100%;
}
.title,.ant-upload-wrapper{
  width: 100%;
}
.css-dev-only-do-not-override-pr0fja.ant-upload.ant-upload-drag {
  height: auto;
}
.css-amq5gd.ant-upload.ant-upload-drag {
  height: auto;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,yDAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;;AAErB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE;;qCAEmC;EACnC,wCAAwC;EACxC,+CAA+C;AACjD;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gKAAgK;EAChK,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,mBAAmB;EACnB,wBAAwB;EACxB,WAAW;EACX,kBAAkB;EAClB,oOAAoO;AACtO;;AAEA;EACE,4BAA4B;EAC5B;;mCAEiC;EACjC,gBAAgB;EAChB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,yCAAyC;EACzC,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;EAClD,4CAA4C;EAC5C,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,sDAAsD;AACxD;;AAEA;EACE;;qCAEmC;EACnC,wCAAwC;EACxC,+CAA+C;;EAE/C,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;;;;AAKA,SAAS;;AAET;EACE,iBAAiB;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ;AACF;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE;AACF;;AAEA;EACE,aAAa;EACb;AACF;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;;AAGA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB;AACF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX;AACF;;AAEA;EAGE,mBAAmB;EAGnB,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV;AACF;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB;AACF;AACA;EACE,eAAe;AACjB;;AAEA;IACI,+BAA+B;AACnC;AACA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;IACT,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;AACA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,SAAS;EACT,YAAY;EACZ;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX;AACF;;AAEA;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX;AACF;;;AAGA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;;AAGA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B;AACF;;AAEA;EACE,qBAAqB;EACrB;AACF;;AAEA;EACE,qBAAqB;EACrB;AACF;;;;AAIA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;;AAEF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;AAEF;;AAEA;EACE;IACE,6BAA6B;EAC/B;;AAEF;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;EACjB;;AAEF;;AAEA;EACE;IACE,6BAA6B;EAC/B;;AAEF;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;;AAEA;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd","sourcesContent":["body {\n  --color1: #61a4bc;\n  --color2: #1a132f;\n  --aqua3: mediumaquamarine;\n  --color4: #bbeff8ce;\n  --boxshadow: #e6e1e1ce;\n  background-image: url(\"../public/bg.svg\");\n  background-size: cover;\n}\n\n*{\n  box-sizing: border-box;\n}\n\nbutton.btn-sm.btn.btn-color.mx-5 {\n  color: black;\n}\n\n.category_post_img img,\n.feature-img img {\n  width: 100%;\n}\n\n.all_post .sidebar_widget .single_sidebar_wiget {\n  padding: 30px;\n  margin-bottom: 30px;\n}\n\n.a_un_underline:hover {\n  text-decoration: none;\n  color: black\n}\n\n.test {\n  position: absolute;\n  width: 80vw;\n  height: 80vw;\n  background-color: red;\n  top: -20vw;\n  left: -20vw;\n  border-radius: 200px;\n  transform: rotate(45deg);\n}\n\n.navbar-brand {\n  width: 216px;\n  margin: 0px;\n  display: flex;\n  align-items: center;\n\n}\n\n.logo {\n  color: white;\n  transition: linear 1s;\n  font-family: \"Oleo Script\", cursive;\n}\n\n.logo:hover {\n  background: linear-gradient(90deg,\n      rgb(247, 64, 207) 0%,\n      rgba(11, 113, 172, 0.966) 100%);\n  -webkit-background-clip: text !important;\n  -webkit-text-fill-color: transparent !important;\n}\n\n.truncate {\n  width: 95%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\nh1.text-color {\n  font-weight: 400;\n}\n\nh1.text-color span {\n  font-weight: 700;\n}\n\n.uk-card.uk-card-default.uk-card-hover.uk-card-body.form-section {\n  width: 100%;\n}\n\nul.navbar-nav.sp-font.h5 {\n  display: flex;\n  column-gap: 80px;\n}\n\nnav.navbar.navbar-expand-lg.navbar-light.bg-light::after {\n  /* content: ''; */\n  background-image: url(https://png.pngtree.com/background/20211217/original/pngtree-noise-texture-abstract-black-gray-white-background-picture-image_1575985.jpg);\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  border-radius: 10px;\n  background-size: inherit;\n  z-index: -1;\n  /* opacity: 0.5; */\n  background-image: url(https://media.istockphoto.com/id/1317698849/vector/space-starry-backdrop-deep-cosmic-wallpaper-wide-cosmos-with-shining-stars-beautiful.jpg?s=612x612&w=0&k=20&c=ZfgqI_ODv-v9PprIZAMVZ8Jyfo5tRWUERsbjzcLWLiE=);\n}\n\n.navbar {\n  background: rgb(0, 212, 255);\n  /* background: linear-gradient(90deg,\n      rgba(0, 212, 255, 1) 11%,\n      rgba(100, 209, 78, 1) 98%); */\n  position: sticky;\n  top: 0px;\n  z-index: 2;\n  width: 98%;\n  margin: 10px auto;\n  border-radius: 10px;\n}\n\n.headline {\n  font-family: \"Oleo Script\", cursive;\n  color: var(--aqua3);\n  box-shadow: -1.6px 3px 10px var(--color4);\n  border-radius: 0.5em;\n  margin-bottom: 3vh;\n}\n\n.headline:hover {\n  cursor: default;\n}\n\n.card {\n  border-radius: 1em;\n  transition: cubic-bezier(0.075, 0.82, 0.165, 1) 1s;\n  box-shadow: -1.6px 3px 10px var(--boxshadow);\n  z-index: 1;\n}\n\n.card:hover {\n  transform: scale(1.01);\n}\n\n.card-img-top {\n  border-radius: 1em 1em 0.1em 0.1em;\n}\n\n.page-button {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n}\n\n.nav-link {\n  color: white !important;\n  transition: cubic-bezier(0.175, 0.885, 0.32, 1.275) 1s;\n}\n\n.nav-link:hover {\n  background: linear-gradient(90deg,\n      rgb(247, 64, 207) 0%,\n      rgba(11, 113, 172, 0.966) 100%);\n  -webkit-background-clip: text !important;\n  -webkit-text-fill-color: transparent !important;\n\n  transform: scale(1.03);\n}\n\n.navbar-toggler {\n  background-color: var(--color1) !important;\n}\n\n.btn-color {\n  background-color: var(--color1);\n  color: white;\n}\n\n\n\n\n/* news */\n\n.list-news-subfolder .item-news-common {\n  padding-top: 20px;\n  margin-top: 20px\n}\n\n.list-news-subfolder .item-news-common .title-news {\n  margin-bottom: 5px;\n  font-size: 18px;\n  font-weight: bold\n}\n\n.list-news-subfolder .item-news-common .thumb-art {\n  width: 260px;\n  margin-right: 0;\n  float: right;\n  margin-left: 40px\n}\n\n.list-news-subfolder .item-news-common .description {\n  font-size: 14px;\n  line-height: 140%;\n  color: #4f4f4f !important\n}\n\n.infinite-scroll-component {\n  overflow-x: hidden !important;\n}\n\n.list-news-subfolder .item-news-common.off-thumb .title-news,\n.list-news-subfolder .item-news-common.off-thumb .description {\n  max-width: 600px\n}\n\n.list-news-subfolder .item-news-common:first-of-type {\n  margin-top: 0;\n  padding-top: 0\n}\n\n.list-news-subfolder .item-news-common.thumb-left {\n  padding-right: 20px\n}\n\n.list-news-subfolder .item-news-common.thumb-left .thumb-art {\n  float: left;\n  width: 240px;\n  margin: 0 20px 0 0\n}\n\n.wrapper-24h .col-left-subfolder {\n  width: 780px;\n  padding-right: 20px\n}\n\n.wrapper-24h .col-right-subfolder {\n  width: 320px;\n  padding-left: 20px\n}\n\n\n.wrapper-24h .list-news-subfolder .item-news-common {\n  padding-left: 30px;\n  position: relative;\n  border-top: none;\n  margin-top: 20px;\n  padding-top: 20px;\n  width: 100%;\n}\n\n.wrapper-24h .list-news-subfolder .item-news-common:first-of-type {\n  margin-top: 0;\n  padding-top: 0\n}\n\n.wrapper-24h .list-news-subfolder .item-news-common .title-news {\n  font-size: 18px;\n  font-weight: 700\n}\n\n.wrapper-24h .ant-list-items {\n  transform: translateX(12px);\n  border-left: 1px solid #e5e5e5;\n}\n\n.wrapper-24h .time-count {\n  font-size: 14px;\n  width: 100%;\n  float: left;\n  position: relative;\n  color: #757575\n}\n\n.rc-virtual-list-holder {\n  overflow-y: visible !important;\n}\n\n.wrapper-24h .time-count:before {\n  content: \"\";\n  width: 9px;\n  height: 9px;\n  background: #9f224e;\n  border-radius: 50%;\n  position: absolute;\n  top: 3px;\n  left: -35px;\n  z-index: 1\n}\n\n.wrapper-24h .filter-viewmore {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n  font-size: 14px;\n  color: #757575;\n  position: absolute;\n  top: -84px;\n  right: 0\n}\n\n.wrapper-24h .filter-viewmore .txt-fil {\n  margin-right: 5px\n}\n\n.wrapper-24h .filter-viewmore .btn_vne {\n  height: 32px;\n  font-size: 15px;\n  color: #757575;\n  line-height: 32px;\n  padding: 0 10px;\n  background: #f7f7f7;\n  border-radius: 3px;\n  margin-left: 5px\n}\n.single_catagory_post{\n  padding: 20px 0;\n}\n\n.single_catagory_post ~ .single_catagory_post {\n    border-top: 1px solid #1ca2fb61;\n}\n.ant-skeleton.ant-skeleton-element.ant-skeleton-active ,.ant-skeleton-image{\n  width: 100%;\n  min-width: 100%;\n  height: 180px;\n  min-height: 180px;\n}\n.category_post_img{\n  width: 100%;\n  height: 180px;\n  position: relative;\n}\n.category_post_img img{\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.Detail img{\n  width: 100%;\n    height: auto;\n    max-width: 100%;\n    padding: 10px 0px;\n}\n.wrapper-24h .filter-viewmore .btn_vne.active {\n  background: #9f224e;\n  color: #fff\n}\n\n.wrapper-24h.wrapper-xemnhieu .list-news-subfolder {\n  border-left: none\n}\n\n.wrapper-24h.wrapper-xemnhieu .list-news-subfolder .item-news-common {\n  padding-left: 0;\n  border-top: 1px solid #e5e5e5\n}\n\n.wrapper-24h.wrapper-xemnhieu .list-news-subfolder .item-news-common:first-of-type {\n  border-top: none\n}\n\n.wrapper-24h.wrapper-xemnhieu .list-news-subfolder .item-news-common:first-of-type .title-news {\n  color: #9f224e\n}\n\n.wrapper-24h.wrapper-hotnews .time-count {\n  height: 0;\n  font-size: 0;\n  margin-bottom: 0\n}\n\n.wrapper-24h.wrapper-hotnews .time-count:before {\n  top: 9px\n}\n\na:focus {\n  outline: 1 !important\n}\n\na {\n  color: inherit;\n  text-decoration: none;\n  outline: 1\n}\n\n.thumb-art {\n  position: relative;\n  margin-right: 10px;\n  float: left;\n  width: 140px\n}\n\n.thumb {\n  display: block;\n  overflow: hidden;\n  height: 0;\n  position: relative;\n  width: 100%;\n  background: #f4f4f4\n}\n\n.thumb img {\n  -o-object-fit: cover;\n  object-fit: cover;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  height: 100%\n}\n\n\n.thumb-5x3 {\n  padding-bottom: 60%\n}\n\n.thumb-5x2 {\n  padding-bottom: 40%\n}\n\n.thumb-3x2 {\n  padding-bottom: 66.66667%\n}\n\n.thumb-16x9 {\n  padding-bottom: 56.25%\n}\n\n.thumb-1x1 {\n  padding-bottom: 100%\n}\n\n.thumb-2x3 {\n  padding-bottom: 150%\n}\n\n\n.meta-news {\n  color: #757575;\n  font-size: 12px;\n  line-height: 14px;\n  font-weight: 400 !important;\n  font-family: Arial\n}\n\n.meta-news .time-public {\n  display: inline-block;\n  margin-right: 10px\n}\n\n.meta-news .cat {\n  display: inline-block;\n  margin-right: 10px\n}\n\n\n\n.item-news-common {\n  margin-bottom: 15px;\n}\n\n.item-news-common {\n  border-bottom: none;\n}\n\n.sidebar-1 img {\n  width: 100%;\n}\n\n.desc_cation p,\n.desc_cation p.Image {\n  /* font: 400 14px/160% arial; */\n  padding: 10px 0 0 0;\n  margin-bottom: 0;\n  text-align: left;\n}\n\n.fck_detail .Normal,\n.fck_detail p {\n  margin: 0 0 1em;\n  line-height: 160%;\n  text-rendering: optimizeSpeed;\n}\n\n.sidebar-1 .header-content,\n.sidebar-1 .title-detail {\n  display: none;\n}\n\n@media screen and (max-width: 979px) {\n  .page-detail.top-detail .sidebar-1 {\n    max-width: calc(100% - 60px);\n  }\n}\n\n@media screen and (max-width: 1129px) {\n  .page-detail.top-detail .sidebar-1 {\n    max-width: calc(100% - 360px);\n  }\n\n}\n\n@media (max-width: 979px) {\n  .page-detail.top-detail .sidebar-1 {\n    max-width: calc(100% - 65px);\n  }\n}\n\n@media screen and (max-width: 979px) {\n  .page-detail.top-detail .sidebar-1 {\n    max-width: 100%;\n  }\n\n}\n\n@media screen and (max-width: 1129px) {\n  .page-detail.top-detail .sidebar-1 {\n    max-width: calc(100% - 320px);\n  }\n\n}\n\n.page-detail.top-detail .sidebar-1 {\n  width: 100%;\n  max-width: calc(100% - 420px);\n  padding: 20px 0 0 0;\n}\n\n@media screen and (max-width: 979px) {\n  .page-detail .sidebar-1 {\n    max-width: 100%;\n  }\n\n}\n\n@media screen and (max-width: 1129px) {\n  .page-detail .sidebar-1 {\n    max-width: calc(100% - 320px);\n  }\n\n}\n\n.sidebar-1 {\n  font-size: 16px;\n  width: 100%;\n  padding: 20px 0 0 0;\n  position: relative;\n}\n.fck_detail table.tplCaption td.caption, .fck_detail table.tplCaption td.Image, .fck_detail table.tplCaption td p.Normal, .fck_detail table.tplCaption td .Image, .fck_detail .tplCaption .Image {\n  font: 400;\n  line-height: 160%;\n  color: #222;\n  padding: 10px 0 0 0;\n  margin: 0;\n  text-align: left;\n}\n.fck_detail figure.tplCaption figcaption p {\n  font: 400 13px/160% arial ;\n  padding-top: 10px;\n  margin-bottom: 0;\n  font-style: italic;\n}\npicture img {\n  position: absolute;\n  width: 100%;\n  left: 0;\n  height: 100%;\n}\n.footer-content{\n  display: none;\n}\n.sidebar-1 table{\n  display: none;\n}\np.Normal,p.description {\n  text-align: justify;\n}\nfigcaption p.Image{\n  \n}\n\n.f-center{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.t-center{\n  text-align: center;\n}\n\n#scrollableDiv{\n  max-width: 100%;\n}\n.title,.ant-upload-wrapper{\n  width: 100%;\n}\n.css-dev-only-do-not-override-pr0fja.ant-upload.ant-upload-drag {\n  height: auto;\n}\n.css-amq5gd.ant-upload.ant-upload-drag {\n  height: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
